import { render } from "./Index.vue?vue&type=template&id=5259b06f&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=5259b06f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5259b06f"

export default script